import { ToggleButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WidgetProps } from "@rjsf/core";
import WidgetLabel from "components/JsonForm/theme/widgets/WidgetLabel";
import { itemValuesFromDbStringWithIcons } from "components/utils";
import "./style.scss";

export function ImageRadioWidget({ id, rawErrors, schema, required, label, readonly, uiSchema, value, disabled, onChange }: WidgetProps) {
    const itemValues = itemValuesFromDbStringWithIcons(uiSchema["af:dbString"]);
    const isError = rawErrors?.length > 0;

    return (
        <fieldset role="radiogroup" aria-required={required}>
            {label && (
                <WidgetLabel
                    id={id}
                    isFieldset
                    label={label}
                    uiSchema={uiSchema}
                    schema={schema}
                    required={required}
                    rawErrors={rawErrors}
                />
            )}
            <div className="image-radio ">
                {(itemValues ?? []).map((item, index) => {
                    const checked = item[0] === value;

                    const radioId = `${id}-${index}`;
                    return (
                        <ToggleButton
                            key={radioId}
                            id={radioId}
                            name={id}
                            disabled={disabled || readonly}
                            type="checkbox"
                            variant={isError ? "outline-danger" : "outline-primary"}
                            className={"w-100 d-flex gap-5 py-4 px-4 align-items-center"}
                            value={item[0]}
                            checked={checked}
                            onChange={() => onChange(item[0])}
                        >
                            {item[2] && (
                                <div style={{ height: "2.8rem", width: "2rem" }}>
                                    <FontAwesomeIcon style={{ height: "100%" }} icon={item[2]} />
                                </div>
                            )}
                            <div className="d-flex lh-sm flex-column text-break text-start gap-2">
                                <span className="fs-5 line-clamp-1 overflow-hidden">{item[1]}</span>
                                <span className="fs-6 line-clamp-4 overflow-hidden text-start">{item[0]}</span>
                            </div>
                        </ToggleButton>
                    );
                })}
            </div>
        </fieldset>
    );
}
